// STEP 2 · agent s2a7 — A7 (B-1e follow-up): rows tagged "current period" but dated outside the engagement period are left
// out of BOTH row populations (journal entry testing and sampling) and listed apart (components/OutOfPeriodRows.jsx).
// Loaded from lib/i18n/ by the generated index (STEP 2 · B2). EN + AR.
export const I18N_S2A7 = {
  en: {
    s2a7: {
      outOfPeriod: {
        je: "{n} line(s) tagged as current period are dated outside the period: left out of journal entry testing and of every sampling population.",
        sampling: "{n} line(s) tagged as current period are dated outside the period: left out of this population and of journal entry testing.",
        show: "Show them",
        hide: "Hide",
        title: "Lines tagged current period, dated outside the period",
        capped: "The first {cap} lines are listed.",
        before: "Before the period",
        after: "After the period",
        col: { voucher: "Voucher", date: "Entry date", account: "Account", debit: "Debit", credit: "Credit", where: "Dated" },
      },
    },
  },
  ar: {
    s2a7: {
      outOfPeriod: {
        je: "{n} سطر/أسطر مصنّفة كفترة حالية مؤرّخة خارج الفترة: مستبعدة من اختبار قيود اليومية ومن كل مجتمعات العينات.",
        sampling: "{n} سطر/أسطر مصنّفة كفترة حالية مؤرّخة خارج الفترة: مستبعدة من هذا المجتمع ومن اختبار قيود اليومية.",
        show: "عرضها",
        hide: "إخفاء",
        title: "أسطر مصنّفة كفترة حالية ومؤرّخة خارج الفترة",
        capped: "تُعرض أول {cap} سطر.",
        before: "قبل الفترة",
        after: "بعد الفترة",
        col: { voucher: "القيد", date: "تاريخ القيد", account: "الحساب", debit: "مدين", credit: "دائن", where: "التاريخ" },
      },
    },
  },
};

export default I18N_S2A7;
